import React from "react";
import { Alert, Button, Col, Form, Row, Toast } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "react-image-crop/dist/ReactCrop.css";
import { useNavigate } from "react-router-dom";

import { useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { DevModal } from "@components/Helpers";
import { buildGetParamsFromApiData, buildQS } from "@components/Utils";

export function ModalDelete() {
    const { t } = useTranslation();
    const { apiData, setApiData, delData, setDelData } = useAppContext();
    const { api_delete } = useRequest();

    const show = Boolean(delData.url);
    const { filterHandler } = delData;

    const handleClose = () => setDelData({});
    const handleModalDeleteSubmit = (ev) => {
        ev.preventDefault();

        api_delete(ev, delData.url, {
            then: (resp) => {
                if (resp.status === "ok") {
                    if (delData.afterRespOK) {
                        delData.afterRespOK(resp);
                    } else {
                        let object_list = [];
                        if (typeof filterHandler === "function") {
                            object_list = filterHandler(resp);
                        } else if ("ids" in resp) {
                            object_list = apiData.object_list.filter((o) => !resp.ids.includes(o.id));
                        } else {
                            object_list = apiData.object_list.filter((o) => o.id !== resp.id);
                        }
                        setApiData({ ...apiData, object_list });
                    }
                }
                handleClose();
            },
        });
    };

    return (
        <DevModal
            show={show}
            onHide={handleClose}
            header={delData.confirmation || t("Подтвердите удаление")}
            footer={
                <DevForm.Button variant="danger" type="submit" name="modal_delete" onClick={handleModalDeleteSubmit}>
                    {t("Удалить")}
                </DevForm.Button>
            }
        />
    );
}

export function ModalFilterGames({ show, setShow, apiData, setApiData, prefix }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => setShow(false);

    const filterAndClose = () => {
        handleClose();
        const getParams = buildGetParamsFromApiData({ apiData, prefix, filterEmptyStrings: true });
        navigate({ search: "?" + buildQS(getParams) });
    };

    const handleReset = () => {
        const resetFilterData = { ...apiData };
        resetFilterData.forms_data.filter.data = {};
        setApiData(resetFilterData);
        filterAndClose();
    };

    const FilterRowWithCondition = ({ field }) => (
        <Row>
            <Col md={9}>
                <DevForm.Field colLabel={4} colField={8} prefix={prefix} name={field} />
            </Col>
            <Col md={3}>
                <DevForm.Field colField={12} hideLabel={true} prefix={prefix} name={`${field}_cond`} />
            </Col>
        </Row>
    );

    return (
        <DevModal
            size="xl"
            show={show}
            onHide={handleClose}
            header={t("Фильтр")}
            body={
                <>
                    <DevForm.Field prefix={prefix} name="name" />
                    <DevForm.Field prefix={prefix} name="visibility_state" />
                    <FilterRowWithCondition field="main_type" />
                    <DevForm.Field prefix={prefix} name="type" />
                    <DevForm.Field prefix={prefix} name="exclude_type" />
                    <FilterRowWithCondition field="genre" />
                    <FilterRowWithCondition field="publication_platform" />
                    <DevForm.Field prefix={prefix} name="moderation" />
                    <DevForm.Field prefix={prefix} name="gc_server_type" />
                    <DevForm.Field prefix={prefix} name="feature_flags" />
                    <DevForm.Field prefix={prefix} name="exclude_feature_flags" />
                    <DevForm.Field prefix={prefix} name="special_flags" />
                    <DevForm.Field prefix={prefix} name="exclude_special_flags" />
                    <DevForm.Field prefix={prefix} name="developer" />
                    <Row>
                        <Col md={9}>
                            <DevForm.Field colLabel={4} colField={8} prefix={prefix} name="m2m_publishers" />
                        </Col>
                        <Col md={3}>
                            <DevForm.Field colField={12} prefix={prefix} name="without_publisher" />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={9}>
                            <DevForm.Field colLabel={4} colField={8} prefix={prefix} name="m2m_gamedevs" />
                        </Col>
                        <Col md={3}>
                            <DevForm.Field colField={12} prefix={prefix} name="without_gamedev" />
                        </Col>
                    </Row>
                    <DevForm.Field prefix={prefix} name="developer_info" />
                    <DevForm.Field prefix={prefix} name="payments_stopped" />
                    <DevForm.Field prefix={prefix} name="supported_os" />
                    <FilterRowWithCondition field="labels" />
                    <DevForm.Field prefix={prefix} name="cloud_game" />
                    <DevForm.Field prefix={prefix} name="only_cloud_available" />
                    <DevForm.Field prefix={prefix} name="is_steam_gift" />
                    <DevForm.Field prefix={prefix} name="hide_cloud_developer" />
                    <DevForm.Field prefix={prefix} name="is_laboratory" />
                    <DevForm.Field prefix={prefix} name="is_sunduki" />
                    <DevForm.Field prefix={prefix} name="is_non_commercial" />
                    <DevForm.Field prefix={prefix} name="without_box" />
                </>
            }
            footer={
                <>
                    <Button variant="light" onClick={handleReset}>
                        {t("Сброс")}
                    </Button>
                    <DevForm.Button variant="primary" type="submit" name="game_search" onClick={filterAndClose}>
                        {t("Найти")}
                    </DevForm.Button>
                </>
            }
            renderWrapper={(children) => <Form onSubmit={filterAndClose}>{children}</Form>}
        />
    );
}

export function ModalFilter({ show, setShow, apiData, setApiData, prefix }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => setShow(false);

    const filterAndClose = () => {
        handleClose();
        const getParams = buildGetParamsFromApiData({ apiData, prefix, filterEmptyStrings: true });
        navigate({ search: "?" + buildQS(getParams) });
    };

    const handleReset = () => {
        const resetFilterData = { ...apiData };
        resetFilterData.forms_data.filter.data = {};
        setApiData(resetFilterData);
        filterAndClose();
    };

    return (
        <DevModal
            size="xl"
            show={show}
            onHide={handleClose}
            header={t("Фильтр")}
            centered={true}
            body={<RenderForm prefix={prefix} apiData={apiData} setApiData={setApiData} bareForm={true} />}
            footer={
                <>
                    <Button variant="light" onClick={handleReset}>
                        {t("Сброс")}
                    </Button>
                    <DevForm.Button variant="primary" type="submit" name="filter_submit" onClick={filterAndClose}>
                        {t("Найти")}
                    </DevForm.Button>
                </>
            }
            renderWrapper={(children) => (
                <Form onSubmit={filterAndClose} id="id-filters-modal">
                    {children}
                </Form>
            )}
        />
    );
}

export function ToastAlert() {
    const { t } = useTranslation();
    const { toastMessage, setToastMessage } = useAppContext();
    return (
        <Toast
            style={{
                position: "fixed",
                top: "30px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1051,
            }}
            delay={10000}
            autohide
            show={Boolean(toastMessage)}
            onClose={() => setToastMessage(null)}
        >
            <Toast.Header>
                <strong className="mr-auto">{t("Ошибка")}</strong>
            </Toast.Header>
            <Toast.Body>
                <Alert variant="danger">
                    <div dangerouslySetInnerHTML={{ __html: toastMessage }} />
                </Alert>
            </Toast.Body>
        </Toast>
    );
}
